<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'RawMaterialHome'
  }
</script>

<style lang="scss">
</style>
